import { render } from "./pagenotfound.vue?vue&type=template&id=10a0d4fc"
import script from "./pagenotfound.vue?vue&type=script&lang=js"
export * from "./pagenotfound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__